import { TabsModel } from './tabs.model';
import { Component, HostListener, EventEmitter, Output, Input } from '@angular/core';
import { InfiniteListModel } from './infiniteList.model';
import { MaskHelper } from '../../helpers/mask';

@Component({
  selector: 'app-infinite-scroll-list',
  templateUrl: './infinite-scroll-list.component.html',
  styleUrls: ['./infinite-scroll-list.component.less']
})
export class InfiniteScrollListComponent {

  @Input() tabs: Array<TabsModel> = new Array<TabsModel>();
  @Input() bottom;
  @Input() currentPage: number;
  @Input() children: Array<InfiniteListModel> = new Array<InfiniteListModel>();
  @Output() pageHitBottom: EventEmitter<number> = new EventEmitter<number>();
  @Output() filterByDays: EventEmitter<number> = new EventEmitter<number>();
  @Output() clickOnChild: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body, html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight && !this.bottom) {
      this.currentPage++;
      this.pageHitBottom.next(this.currentPage);
    }
  }

  onTabClick(event) {
    if (event.index === 0) {
      this.filter(7);
    } else if (event.index === 1) {
      this.filter(30);
    } else if (event.index === 2) {
      this.filter(60);
    } else {
      this.filter(7);
    }
  }

  openChildDetail(id: string) {
    this.changeChildOpenStatus(id, true);
    this.clickOnChild.next(id);
  }

  closeChildDetal(id: string) {
    this.changeChildOpenStatus(id, false);
  }

  private changeChildOpenStatus(id: string, status: boolean) {
    const child = this.children.find(_child => {
      return _child.id === id;
    });
    if (!status) {
      child.detail = [];
    }
    child.open = status;
  }

  filter(period) {
    this.filterByDays.next(period);
  }

  formatLocalDate(date: string) {
    return MaskHelper.formatDate(date);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/infinite-scroll-list/infinite-scroll-list.component.ts